import { Dispatch, SetStateAction } from 'react';

import { message as AntdMessage } from 'antd';
import FileSaver from 'file-saver';

import { useApi } from 'hooks/ApiStoreContext';
import { useHandleBackErrors } from 'hooks/utils/handleBackErrors';
import { extractFileNameFromContentDisposition } from 'utils/requestUtils';

export function useDownloadPieceJointe(
  setLoading: Dispatch<SetStateAction<boolean>>,
  dossierId: string,
): (type: string) => void {
  const controllerApi = useApi().PieceJointeControllerApi;
  const behaviourOnError = useHandleBackErrors();

  return async type => {
    setLoading(true);
    await controllerApi
      .downloadUsingGET(dossierId, type)
      .then((result: Response) => {
        const fileName = extractFileNameFromContentDisposition(result);

        if (fileName === undefined) {
          void AntdMessage.error(
            'Erreur lors du téléchargement: Veuillez réessayer ultérieurement',
          );
          return;
        }

        // Create dom link to download file
        result
          .blob()
          .then((blob: Blob) => {
            FileSaver.saveAs(blob, fileName);
          })
          .catch(behaviourOnError);
      })
      .catch((errorResponse: Response) => {
        behaviourOnError(errorResponse);
      })
      .finally(() => setLoading(false));
  };
}
